import { observer } from 'mobx-react';
import LearningCollectionEditStore from '../../../../Store';
import { ProductLicenseResource } from '../../../../../../Types';
import { filterOnlySelectedInactiveLicense } from '../../../../../CurrentCollectionStep/ChooseProductLicense/Left/ActiveProductLicense/Selection';
import InActiveProductLicense from './InActiveProductLicense';
import { emptyFragment } from '../../../../../../../../EmptyFragment';

interface Props {
  store: LearningCollectionEditStore;
  inactiveProductLicenses: ProductLicenseResource[];
}

function InActiveProductLicenses({ store, inactiveProductLicenses }: Props) {
  return (
    <div data-intercom-target="edit-inactive-product-licenses-list">
      {filterOnlySelectedInactiveLicense(store, inactiveProductLicenses)
        .map((inactiveLicense) => (
          <InActiveProductLicense
            key={inactiveLicense.first.payload.id}
            store={store}
            inactiveProductLicenses={inactiveLicense.first}
            dataIntercomTarget="edit-inactive-product-license"
          />
        ))
        .getOrElse(emptyFragment)}
    </div>
  );
}

export default observer(InActiveProductLicenses);
